import '@forest/shared/polyfills'

import './setup'

import { render } from 'solid-js/web'
import '~/styles/global.css'
import { App } from './app'

render(() => <App />, document.getElementById('root')!)
